<!--
 - Author : wanghongling.
 - Date   : 2019/6/11.
 - File   : resInfo.承包商信息详情
 -->

<template>
  <div>
    <popup :title="resInfo.theTitle" width="780px" :state="resInfo.theState" @closeEvent="resInfo.resShow = false">
      <div class="detail-wrap">
        <div class="detail-list" v-show="Object.keys(tmpLicenseInfo).length">
          <div class="detail-list-name">
            <div class="detail-list-name-left">食品经营许可证信息</div>
            <div class="detail-list-name-right"></div>
          </div>
          <div class="detail-list-content">
            <div class="detail-list-content-left">
              <div class="lb">
                <p class="lieb-l">
                  <span>许可证编号</span>{{tmpLicenseInfo.licenseInfoResultApiModel && (tmpLicenseInfo.licenseInfoResultApiModel.licenseNo||'JY24403785420990')}}
                </p>
                <p class="lieb-r">
                  <span>经营项目</span><span style="flex: 1"><b>{{tmpLicenseInfo.itemCn|filterSeparator}}</b></span>
                </p>
              </div>
              <div class="lb">
                <p class="lieb-l">
                  <span>法定代表人</span>{{tmpLicenseInfo.licenseInfoResultApiModel &&
                  (tmpLicenseInfo.licenseInfoResultApiModel.legalRepresentative ||'林琳')}}
                </p>
                <p class="lieb-r">
                  <span>有效期至</span>{{tmpLicenseInfo.licenseInfoResultApiModel &&
                  (tmpLicenseInfo.licenseInfoResultApiModel.expireDate ||'2019年04月31日')}}<b
                    :class="[tmpLicenseInfo.licenseInfoResultApiModel.status!=='2'?'lb-state':'lb-state2']"
                    v-if="tmpLicenseInfo.licenseInfoResultApiModel">
                  {{tmpLicenseInfo.licenseInfoResultApiModel.status|filterSXkztate}}</b>
                </p>
              </div>
              <div class="lb">
                <p class="lieb-l">
                  <span>主体业态</span>{{tmpLicenseInfo.licenseInfoResultApiModel &&
                  (tmpLicenseInfo.licenseInfoResultApiModel.mainBusinessCn||'学校食堂')}}
                </p>
                <p class="lieb-r">
                  <span>经营者名称</span>{{tmpLicenseInfo.licenseInfoResultApiModel &&
                  (tmpLicenseInfo.licenseInfoResultApiModel.businessName||'嘉鑫餐饮管理有限公司')}}
                </p>
              </div>
              <div class="lb">
                <p class="lieb">
                  <span>经营地址</span>{{tmpLicenseInfo.licenseInfoResultApiModel &&
                  (tmpLicenseInfo.licenseInfoResultApiModel.address||'福建省福州市闽侯县科技路6号')}}
                </p>
              </div>
            </div>
            <div class="detail-list-content-right">
              <div class="pic" @click="showPic(imgUrl+tmpLicenseInfo.licenseInfoResultApiModel.fileId[0])">
                <i class="el-icon-zoom-in"></i>
                <img v-if="tmpLicenseInfo.licenseInfoResultApiModel"
                    :src="imgUrl+tmpLicenseInfo.licenseInfoResultApiModel.fileId[0]" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="detail-list" v-show="resInfo.businesslicense">
          <div class="detail-list-name">
            <div class="detail-list-name-left">营业执照信息</div>
            <div class="detail-list-name-right"></div>
          </div>
          <div class="detail-list-content">
            <div class="detail-list-content-left">
              <div class="lb">
                <p class="lieb">
                  <span style="width: 120px;text-align: left;">统一社会信用代码
                  </span>{{resInfo.businesslicense&&resInfo.businesslicense.unifyingSocialCredit}}
                </p>
              </div>
              <div class="lb">
                <p class="lieb-l">
                  <span>类型</span>{{resInfo.businesslicense&&(resInfo.businesslicense.codeTypeName||'暂无')}}
                </p>
                <p class="lieb-r">
                  <span>注册资本</span>{{resInfo.businesslicense&&resInfo.businesslicense.registerValue}}
                </p>
              </div>
              <div class="lb">
                <p class="lieb-l">
                  <span>法定代表人</span>{{resInfo.businesslicense&&resInfo.businesslicense.legalRepresentative}}
                </p>
                <p class="lieb-r">
                  <span>成立日期</span>{{resInfo.businesslicense&&resInfo.businesslicense.companyCreateDate}}
                </p>
              </div>
              <div class="lb">
                <p class="lieb-r1">
                  <span>住所</span>{{resInfo.businesslicense&&resInfo.businesslicense.address}}
                </p>
              </div>
              <div class="lb">
                <p class="lieb-r1">
                  <span>营业期限</span>{{resInfo.businesslicense&&resInfo.businesslicense.businessBegin}}起 <b style="color: #b3b2b3;padding: 0 5px">至</b>
                  {{resInfo.businesslicense&&resInfo.businesslicense.businessEnd||'2019年01月31日二十四时'}}止<br>
                  <b :class="[resInfo.businesslicense.status!=='2'?'lb-state':'lb-state2']" v-if="resInfo.businesslicense">
                    {{resInfo.businesslicense&&resInfo.businesslicense.status|filterSXkztate}}</b>
                </p>
              </div>
              <div class="lb">
                <p class="lieb-r1">
                  <span>经营范围</span>{{resInfo.businesslicense&&resInfo.businesslicense.businessRegion}}
                </p>
              </div>
            </div>
            <div class="detail-list-content-right">
              <div class="pic" @click="showPic(imgUrl+resInfo.businesslicense.fileId[0])">
                <i class="el-icon-zoom-in"></i>
                <img v-if="resInfo.businesslicense"
                    :src="imgUrl+resInfo.businesslicense.fileId[0]" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="detail-list" v-if="resInfo.insuranceInfo&&resInfo.insuranceInfo.length>0">
          <div  v-for="(item, index) in resInfo.insuranceInfo" :key="index">
            <div class="detail-list-name">
              <div class="detail-list-name-left">{{item.insuranceName}}信息</div>
              <div class="detail-list-name-right">
              </div>
            </div>
            <div class="detail-list-content">
              <div class="detail-list-content-left">
                <div class="lb">
                  <p class="lieb-l">
                    <span>保单号</span><span>{{item.insuranceNo||'12691031900317543672'}}</span>
                  </p>
                  <p class="lieb-r">
                    <span>保险名称</span>{{item.insuranceName ||'**保险名称'}}
                  </p>
                </div>
                <div class="lb">
                  <p class="lieb-l">
                    <span>被保险人</span>{{item.insured||'例如：李某'}}
                  </p>
                </div>
                <div class="lb">
                  <p class="lieb">
                    <span>保险期间</span>{{item.beginDate ||'2018年01月31日零时'}}起 <b style="color: #b3b2b3;padding: 0 5px">至</b>
                    {{item.endDate||'2019年01月31日二十四时'}}止<br>
                    <b :class="[item.status!=='2'?'lb-state':'lb-state2']">
                      {{item.status|filterSXkztate}}</b>
                  </p>
                </div>
                <div class="lb">
                  <p class="lieb-r1">
                    <span>投保人地址</span><span>{{item.address||'暂无'}}</span>
                  </p>
                </div>
                <div class="lb">
                  <p class="lieb-r1">
                    <span>备注</span><span>{{item.remarks||'暂无'}}</span>
                  </p>
                </div>
              </div>
              <div class="detail-list-content-right">
                <el-carousel indicator-position="outside" :arrow="item.fileId &&item.fileId.length>1?'hover':'never'">
                  <el-carousel-item v-for="(filed, index) in item.fileId" :key="index">
                    <div class="pic" @click="showPic(imgUrl+filed)">
                      <i class="el-icon-zoom-in"></i>
                      <img :src="imgUrl+filed" v-if="filed" alt="点击查看大图">
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
          class="no-the-data"
          style="height: 420px;"
          v-show="Object.keys(resInfo.licenseInfo).length === 0 && Object.keys(resInfo.insuranceInfo).length === 0 && !resInfo.businesslicense">
        <i class="iconfont icon-mingxi dzi" style="font-size: 40px"></i>
        <p>暂无相关资证</p>
      </div>
    </popup>
  </div>
</template>

<script>
  export default {
    name: 'res-Info',
    data () {
      return {
        imgUrl: this.$store.getters.fileApi
      }
    },
    props: {
      resInfo: {
        default: {
          theTitle: '',
          theState: 2,
          resShow: false,
          imgPic1: '',
          imgPic2: ''
        }
      }
    },
    computed: {
      tmpLicenseInfo () {
       if (this.resInfo.licenseInfo && this.resInfo.licenseInfo.licenseInfoResultApiModel) {
         return this.resInfo.licenseInfo
       } else {
         return {}
       }
      }
    },
    methods: {
      /**
       * 显示查看图片框
       * @author: whl
       * @createDate: 2019/6/4
       * @param item 图片信息
       * @return {Object}
       */
      showPic (item) {
        this.$superMessage('查看图片', '', {imgPic: item, btnShow: false}).then(() => {
          // do something
        }).catch(() => {
          // do something
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../assets/less/color';
  .detail-wrap{
    max-height: 800px;
    /*overflow: auto;*/
    .detail-list{
      padding: 15px 10px 15px 0;
      &-name{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 5px;
        &-left{
          font-size: 18px;
          color: #fff;
        }
        &-right{
          border-bottom: 1px solid #156893;
          flex: 1;
          margin-left: 15px;
        }
      }
      &-content:last-child{
        padding-bottom: 0;
      }
      &-content{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        border-bottom: 1px dashed rgb(7, 94, 109);
        padding-bottom: 10px;
        &-left{
          font-size: 14px;
          .lb{
            display: flex;
            color: #00fffc;
            margin-bottom: 10px;
            .lb-state{
              background-color: @orange;
              padding: 0 5px 2px;
              border-radius: 2px;
              color: #fff !important;
              display: inline-block;
              margin-left: 8px;
            }
            .lb-state2{
              background-color: @stateGreen;
              padding: 0 5px 2px;
              border-radius: 2px;
              color: #fff !important;
              display: inline-block;
              margin-left: 8px;
            }
            .lieb-l{
              width: 250px;
              display: flex;
              word-break: break-all;
              span{
                width: 200px;
              }
              span:first-child{
                width: 70px;
                color: #0aaade;
                margin-right: 5px;
                text-align: right;
              }
            }
            .lieb-r{
              width: 282px;
              display: flex;
              flex-wrap: wrap;
              span:first-child{
                width: 70px;
                color: #0aaade;
                margin-right: 5px;
                text-align: right;
              }
            }
            .lieb-r1{
              display: flex;
              span:first-child{
                width: 70px;
                min-width: 70px;
                color: #0aaade;
                margin-right: 5px;
                text-align: right;
              }
              span{
                display: block;
              }
            }
            .lieb{
              display: flex;
              flex-wrap: wrap;
              span{
                width: 70px;
                color: #0aaade;
                margin-right: 5px;
                text-align: right;
              }
            }
          }
        }
        &-right{
          max-width: 190px;
          max-height: 130px;
          /*overflow: hidden;*/
          .el-carousel__button{
            width: 8px;
            height: 8px;
            border-radius: 50%;
          }
          .pic{
            position: relative;
            width: 100%;
            height: 100%;
            text-align: center;
            overflow: hidden;
            cursor: pointer;
            i{
              width: 100%;
              height: 100%;
              position: absolute;
              font-size: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              background: rgba(0,0,0,0.6);
              opacity: 0;
            }
            img{
              max-width: 100%;
              max-height: 100%;
            }
          }
          .pic:hover i{
            opacity: 1;
          }
        }
      }
      &-content:last-child{
        border-bottom: none;
      }
    }
    /*.detail-list:last-child{*/
    /*padding: 15px 10px 0 0;*/
    /*}*/
    .el-carousel__container{
      height: 130px !important;
      width: 190px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/resInfo.vue